import type { ComponentProps } from "react";

import type ContactDetailsOverlayState from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactDetails/ContactDetailsOverlayState";
import type { IApproveTermsGuardHOCProps } from "app/pages/sales-intelligence/sub-modules/contacts-search/hoc/withApproveTermsGuard";
import withApproveTermsGuard from "app/pages/sales-intelligence/sub-modules/contacts-search/hoc/withApproveTermsGuard";

import ContactDetailsOverlayToButtonAdapter from "./ContactDetailsOverlayToButtonAdapter";

const ContactDetailsWithTermsGuard = withApproveTermsGuard(ContactDetailsOverlayToButtonAdapter);

const ContactDetailsOverlayStateWithTermsGuard = ({
    onReveal,
    ...props
}: ComponentProps<typeof ContactDetailsOverlayState> & IApproveTermsGuardHOCProps) => {
    return (
        <ContactDetailsWithTermsGuard
            {...props}
            onClick={onReveal}
        />
    );
};

export default ContactDetailsOverlayStateWithTermsGuard;
